import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useDeleteCreditNote(
  options?: UseMutationOptions<void, unknown, string>,
) {
  const api = getPrivateApi();

  return useMutation(async (creditLedgerEntryId: string) => {
    await api.deleteCreditNote({ creditLedgerEntryId });
  }, options);
}
